/**
 * 新增 or 编辑
 */
import React, {
  useEffect,
  useReducer,
  useState,
} from 'react'
import { STriggerModal } from 'shj-components'
import { Form, Button, Select, Row, Col, message, Input } from 'antd'
import {estateAreaById, buildingAreaAddOrEdit, httpCompanyList} from '@/services/customerServices'
import {trimStr} from "@/utils/data.ts";

const { Option } = Select

interface IAddOrEditProps {
  reload?: (values: object) => void
  onClose?: (values: object) => void
  record?: any
  open?: boolean
}

const ModalAddOrEditDom = (props: IAddOrEditProps) => {
  const { record, open, reload, onClose } = props
  const [form]: any = Form.useForm()
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const { setFieldsValue }: any = form
  const [state, dispatch]: any = useReducer(
    (state: any, action: any) => {
      return action
    },
    {
      companyList: [],
    }
  )
  const { companyList }: any = state
  const id = record?.id

  useEffect(() => {
    initFn()
  }, [])

  const initFn = () => {
    setSubmitLoading(true)
    Promise.all([httpCompanyList()]).then((resp: any) => {
      console.log('res',resp[0])
      dispatch({ companyList: resp[0] })
      if (id) {
        estateAreaById(id).then((res: any) => {
          setFieldsValue({ ...res })
        })
      }
    }).finally(() => setSubmitLoading(false))
  }
  // 提交
  const onFinish = () => {
    form.validateFields().then((values: any) => {
      const newValues = { ...values }
      newValues.id = id || ''
      setSubmitLoading(true)
      buildingAreaAddOrEdit(id, newValues)
        .then((resp: any) => {
          setSubmitLoading(false)
          message.success(resp?.message || '操作成功')
          onClose?.()
          reload?.()
        })
        .catch(() => {
          setSubmitLoading(false)
        })
    })
  }

  return (
    <STriggerModal
      title={record?.id ? '编辑' : '新增'}
      open={open}
      cancel={true}
      okText="保存"
      onOk={onFinish}
      onCancel={onClose}
      confirmLoading={submitLoading}
      reset={false}
      onReset={() => {
        form.resetFields()
      }}
      destroyOnClose
    >
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item label="公司" name="orgId" rules={[{ required: true, message: '请选择' }]}>
          <Select placeholder="请选择" allowClear disabled={!!id} showSearch options={companyList} fieldNames={{label: 'companyName', value: 'orgId'}} optionFilterProp={'companyName'}/>
        </Form.Item>
        <Form.Item
          label="排序"
          name="rankingWeight"
          rules={[{ required: true, message: '请输入正确序号', pattern: /^[0-9]\d*$/ }]}
        >
          <Input placeholder="请输入排序" />
        </Form.Item>
        <Form.Item label="名称" name="name" rules={[{ required: true, message: '请输入' }]}>
          <Input placeholder="请输入名称" maxLength={20} showCount onChange={(e)=>{form.setFieldValue('name', trimStr(e.target.value))}}/>
        </Form.Item>
      </Form>
    </STriggerModal>
  )
}

export default ModalAddOrEditDom
